import { ActionService } from 'dashboard-services/services';

export default (() => {
  
  const ON_CHANGE = 'ON_CHANGE_SHARE_INSIGHT'
  const onChange = ActionService.makeActionCreator(ON_CHANGE, 'value', 'name')
  return {
    onChange,
    ON_CHANGE
  }
})()
